export const OFFER_MAP_FOCUS_EVENT = 'exchangeOfferMapFocus'

export const focusOfferOnMap = offer => {
  if (typeof window === 'undefined' || !offer || !offer.id) return
  window.dispatchEvent(
    new CustomEvent(OFFER_MAP_FOCUS_EVENT, { detail: offer })
  )
}
